import { SectionWrapper } from '../components/SectionWrapper';

import styles from './PricingSection.module.css';

export function PricingSection() {
  return (
    <SectionWrapper background="soft" data-testid="institutions-section-pricing" id="pricing">
      <div className={styles.section}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            Pricing built for inclusive-access — not against it.
          </h2>
          <p className={styles.subhead}>
            The standard publisher inclusive-access program attempts to bridge
            between affordability and revenue. Kudu starts at a price point that
            makes the program easy to justify. $25 per student per semester.
          </p>
        </div>

        <div className={styles.comparison}>
          <article className={styles.card} data-tone="muted">
            <p className={styles.cardLabel}>Other vendors</p>
            <h3>$80–120+ publisher bundles</h3>
            <p>
              Textbook access, homework, clickers, AI add-ons, support, and
              accessibility reviews often arrive as separate costs with separate
              contracts.
            </p>
          </article>
          <article className={styles.card} data-tone="kudu">
            <p className={styles.cardLabel}>Kudu</p>
            <h3>$25 per student per semester</h3>
            <p>
              Everything included: textbook, homework, AI, polling,
              accessibility, analytics, and course customization in one product.
            </p>
          </article>
        </div>

        <p className={styles.note}>
          Institutional partnership pricing and bookstore workflows can be mapped
          during a short discovery call.
        </p>
      </div>
    </SectionWrapper>
  );
}
